import {
    UiStack,
    UiText,
} from '@experiences/ui-common';
import { FontVariantToken } from '@uipath/apollo-core';
import {
    ApDropdown,
    ApDropdownItem,
    ApProgressSpinner,
} from '@uipath/portal-shell-react';
import React from 'react';
import useSWR from 'swr';

import { getConnectors } from '../../../../services/connector/ConnectorService';

interface ConnectorDropdownProps {
    organizationId: string;
    tenantId: string;
    label?: string;
    onChange: (newValue?: string) => void;
    value?: string;
    required?: boolean;
    disabled?: boolean;
    filter?: (connectorKey: string) => boolean;
}

export const ConnectorDropdown: React.FC<ConnectorDropdownProps> = ({
    organizationId, tenantId, label, onChange, value, required, disabled, filter,
}) => {

    const {
        data, error, isValidating,
    } = useSWR(
        tenantId ? {
            url: 'integration-services-connectors',
            organizationId,
            tenantId,
        } : null,
        () => getConnectors(organizationId, tenantId),
    );

    const filteredData = data ? data.filter(c => !filter || filter(c.key)) : [];

    if (!data && isValidating) {
        return (
            <UiStack direction="column">
                <UiText
                    style={{
                        marginTop: 8,
                        marginBottom: 8,
                    }}
                    variant={FontVariantToken.fontSizeMBold}
                    color="var(--color-foreground-de-emp)">
                    {label}
                </UiText>
                <ApProgressSpinner />
            </UiStack>
        );
    }

    return (
        <ApDropdown
            style={{ width: '240px' }}
            label={label}
            selectedValue={value}
            data-cy="connector-dropdown"
            errorMessage={error?.message}
            required={required}
            disabled={disabled}
            onSelectedValueChanged={(ev) => onChange(ev.detail as string)}>
            {filteredData.map((item) => <ApDropdownItem
                key={item.key}
                value={item.key}
                label={item.name} />)}
        </ApDropdown>
    );
};
